import { FieldSlugEnum } from 'common/enums/FieldSlugEnum'
import { FieldInterface } from 'common/types/entities/field-interface'
import { changeField } from 'publisher/actions/optInActions'
import { useFieldsStorage } from 'publisher/components/entities/Field/hooks/use-fields-storage'
import { useOptIn } from 'publisher/store'
import {
  getFieldErrorsBySlug,
  getFieldValueBySlug,
} from 'publisher/store/optIn/optInSelectors'
import React from 'react'
import { useDispatch } from 'react-redux'
import { BasePublisherPhoneNumberField } from 'src/publisher/entities/base-publisher-field/base-publisher-phone-number-field'

export interface PhoneNumberFieldProps {
  entity: FieldInterface
}

const PhoneNumberField = ({ entity }: PhoneNumberFieldProps) => {
  const dispatch = useDispatch()
  const errors = useOptIn(optIn =>
    getFieldErrorsBySlug(optIn, FieldSlugEnum.PhoneNumber),
  )
  const phoneNumber = useOptIn(optIn =>
    getFieldValueBySlug(optIn, FieldSlugEnum.PhoneNumber),
  )

  const { isReady } = useFieldsStorage(entity.slug ?? '')

  return (
    <BasePublisherPhoneNumberField
      entity={entity}
      value={phoneNumber}
      onChange={value => dispatch(changeField(entity.slug, value))}
      errors={errors}
      isHidden={!isReady}
    />
  )
}

export default PhoneNumberField
